<template>
  <section class="p3 standard section">
    <div class="section-content">
      <div class="left image-wrapper ">
        <img src="../../assets/images/home/p3-standard.png" alt=""/>
      </div>
      <div class="main">
        <div class="h">
          {{ $t('HomeText.p3_title') }}
        </div>
        <div class="c">
          <p>
            {{ $t('HomeText.p3_content') }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "p3-standard",
    data(){
      return {}
    },
  }
</script>

<style scoped lang="scss">
  .p3.standard {
    padding: 4vw 0 2vw;

    .left.image-wrapper {
      flex-shrink: 0;
      width: 41vw;
      height: 36vw;
    }

    .main {
      padding: 0 12vw 0 2vw;

      .h {
        padding: 4vw 0;
        font-weight: bold;
        height: 3vw;
        font-size: 3vw;
        line-height: 1vw;
      }

      .c {

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/p3-standard.vue